import * as React from 'react'
import { removeDisabledStorage } from 'lib/CookieGDPR/removeDisabledStorage'
import { useTranslator } from 'common/hooks/useTranslator'
import * as styles from './scss/styles.module.scss'

const CookieBannerGDPR = React.lazy(() =>
  import('cookieBanner/CookieBannerGDPR')
)

type Props = {
  shouldShowImprint?: boolean
  shouldShowPrivacyNotice?: boolean
}

const onSave = async consent => {
  await removeDisabledStorage(consent)
  location.reload()
}

export const CookieBanner: React.FC<Props> = props => {
  const { shouldShowPrivacyNotice = true, shouldShowImprint = true } = props
  const Translator = useTranslator()

  return (
    <div className={styles.root}>
      <React.Suspense fallback="">
        <CookieBannerGDPR
          onSave={onSave}
          locale={Translator.locale}
          shouldShowImprint={shouldShowImprint}
          shouldShowPrivacyNotice={shouldShowPrivacyNotice}
        />
      </React.Suspense>
    </div>
  )
}
